<template>
  <div>
    <div class="row mb-4">
      <div class="col-12">
        <h3 class="font-weight-bolder bp_color">NEW - SELF EMPLOYED BUSINESS ENTITY TEST</h3>
        <h5>Please complete the test below for: &nbsp;&nbsp;&nbsp;
          <span v-if="'person' in worker && (worker.person !== null && Object.keys(worker.person).length > 1)">{{ worker.person.first_name }} {{ worker.person.surname }}</span>
            &nbsp;
          <span v-if="notEmptyObject(worker) && worker.rel_company_info.company_internal_finance_ref === null">(Ref - {{ worker.internal_finance_ref }})</span>
          <span v-if="notEmptyObject(worker) && worker.rel_company_info.company_internal_finance_ref !== null">(Ref - {{ worker.rel_company_info.company_internal_finance_ref
            }})</span>
          <br>
          <span class="font-weight-bold">All questions require an answer.</span></h5>
      </div>
    </div>

    <ValidationObserver ref="newEntityTestForm" slim>
      <form role="form" @submit.prevent="new_entity_test_submit" class="clearfix">
        <div class="row">
          <!-- Section 1 - Contract Information -->
          <div class="col-12">
            <b-card header="Section 1 - Contract Information" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Using own limited company -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Are you using your own limited company (or that of a payroll service) as the trading vehicle to invoice the agency/client for your services?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No,Don't Know" v-slot="{errors, classes}" name="using your own limited company" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="using_own_ltd_company" value="Yes" v-model="test.using_own_ltd_company">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="using_own_ltd_company" value="No" v-model="test.using_own_ltd_company">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="using_own_ltd_company" value="Don't Know" v-model="test.using_own_ltd_company">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <!-- UK Tax payer -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Are you a UK tax payer?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="UK tax payer" tag="div">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="uk_tax_payer" value="Yes" v-model="test.uk_tax_payer">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="uk_tax_payer" value="No" v-model="test.uk_tax_payer">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
            </b-card>
          </div>
          <!-- Section 2 - Substitution -->
          <div class="col-12">
            <b-card header="Section 2 - Substitution" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Send Substitution -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Under the terms of your contract can you send another contractor to do the work in your place ("Substitution clause")</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No,Don't Know" v-slot="{errors, classes}" name="substitution" tag="div">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="send_substitution" value="Yes" v-model="test.send_substitution">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="send_substitution" value="No" v-model="test.send_substitution">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="send_substitution" value="Don't Know" v-model="test.send_substitution">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
            </b-card>
          </div>
          <!-- Section 3 - Control -->
          <div class="col-12">
            <b-card header="Section 3 - Control" header-tag="h4" body-class="mb-3 pb-2">
              <!-- SDC -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">In your current role are you subject to supervision, direction and/or control?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="supervision" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="s_d_c" value="Yes" v-model="test.s_d_c">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="s_d_c" value="No" v-model="test.s_d_c">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <!-- Switch Projects -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Does your client switch you between projects throughout the duration of your contract as a client’s priorities and workflow's change?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="switch projects" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="switch_projects" value="Yes" v-model="test.switch_projects">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="switch_projects" value="No" v-model="test.switch_projects">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <!-- Named Projects -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Are you contracted on a particular named project which is also specified in the contract?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No,Don't Know" v-slot="{errors, classes}" name="contracted to particular project" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="named_project" value="Yes" v-model="test.named_project">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="named_project" value="No" v-model="test.named_project">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="named_project" value="Don't Know" v-model="test.named_project">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <!-- How work performed -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Do you, the worker, have the freedom to choose how the work is to be performed?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="freedom to choose how work performed" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="how_work_performed" value="Yes" v-model="test.how_work_performed">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="how_work_performed" value="No" v-model="test.how_work_performed">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <!-- Decide Working Hours -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Can the end client decide the scheduled working hours?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No,Partly,Not applicable" v-slot="{errors, classes}" name="end client decides working hours" tag="div">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="decide_working_hours" value="Yes" v-model="test.decide_working_hours">
                      <div class="state p-danger-o"><label>Yes, the client decides the working schedule</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="decide_working_hours" value="No" v-model="test.decide_working_hours">
                      <div class="state p-success-o"><label>No, the worker decide the schedule</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="decide_working_hours" value="Partly" v-model="test.decide_working_hours">
                      <div class="state p-warning-o"><label>Partly the worker and the end client agree schedule</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="decide_working_hours" value="Not applicable" v-model="test.decide_working_hours">
                      <div class="state p-success-o"><label>Not applicable, no schedule needed as long as agreed deadlines are met</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
            </b-card>
          </div>
          <!-- Section 4 - Mutuality of Obligation -->
          <div class="col-12">
            <b-card header="Section 4 - Mutuality of Obligation" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Notice Period -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">What notice period does your contract specify your client must give you if they are terminating the contract?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:No Notice,7 Days,Longer" v-slot="{errors, classes}" name="notice period" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="notice_period" value="No Notice" v-model="test.notice_period">
                      <div class="state p-success-o"><label>No Notice</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="notice_period" value="7 Days" v-model="test.notice_period">
                      <div class="state p-danger-o"><label>7 Days</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="notice_period" value="Longer" v-model="test.notice_period">
                      <div class="state p-danger-o"><label>14&nbsp;Days / 30&nbsp;Days / 1&nbsp;Month / More&nbsp;than&nbsp;30&nbsp;Days</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <!-- Offer other work -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">If the current project you are working on is completed early before your contract end date would the client offer you other work which you would
                    feel; obliged to take on?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No,Don't Know" v-slot="{errors, classes}" name="client offer other work" tag="div">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="offer_other_work" value="Yes" v-model="test.offer_other_work">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="offer_other_work" value="No" v-model="test.offer_other_work">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="offer_other_work" value="Don't Know" v-model="test.offer_other_work">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
            </b-card>
          </div>
          <!-- Section 5 - Financial Risk -->
          <div class="col-12">
            <b-card header="Section 5 - Financial Risk" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Correct Errors -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">In the event that errors have been discovered in work that you have undertaken. Are you expected to correct these errors without charging
                    additional fees?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No,Don't Know" v-slot="{errors, classes}" name="fixing errors" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="correct_errors" value="Yes" v-model="test.correct_errors">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="correct_errors" value="No" v-model="test.correct_errors">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="correct_errors" value="Don't Know" v-model="test.correct_errors">
                      <div class="state p-warning-o"><label>Don't Know</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <!-- Last Permanent Employer -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Is your current client your last permanent employer?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="client last permanent employer" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="last_permanent_employer" value="Yes" v-model="test.last_permanent_employer">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="last_permanent_employer" value="No" v-model="test.last_permanent_employer">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <!-- Entitlements -->
              <div class="row">
                <div class="col-12">
                  <p class="font-weight-bold">Are you entitled to or have you received any of the following paid for by the end user;</p>
                </div>
                <!-- Sick Pay -->
                <div class="col-xl-8">
                  <p class="mb-2">Sick Pay</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="sick pay" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="sick_pay" value="Yes" v-model="test.sick_pay">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="sick_pay" value="No" v-model="test.sick_pay">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
                <!-- Holiday Entitlement -->
                <div class="col-xl-8">
                  <p class="mb-2">Holiday Entitlement</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="holiday entitlement" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="holiday_entitlement" value="Yes" v-model="test.holiday_entitlement">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="holiday_entitlement" value="No" v-model="test.holiday_entitlement">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
                <!-- Work Place Pension -->
                <div class="col-xl-8">
                  <p class="mb-2">Work Place Pension</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="work place pension" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="work_place_pension" value="Yes" v-model="test.work_place_pension">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="work_place_pension" value="No" v-model="test.work_place_pension">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
                <!-- Maternity / Paternity -->
                <div class="col-xl-8">
                  <p class="mb-2">Maternity / Paternity</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="maternity paternity" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="maternity_paternity" value="Yes" v-model="test.maternity_paternity">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="maternity_paternity" value="No" v-model="test.maternity_paternity">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
                <!-- Paid Training -->
                <div class="col-xl-8">
                  <p class="mb-2">Paid training (this does not include any training on internal systems or procedures)</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="paid training" tag="div">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="paid_training" value="Yes" v-model="test.paid_training">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="paid_training" value="No" v-model="test.paid_training">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
            </b-card>
          </div>
          <!-- Section 6 - Business on own Account -->
          <div class="col-12">
            <b-card header="Section 6 - Business on own Account" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Restrict other work -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Does your contract include any clauses that restrict you from performing paid work from another client during the contract?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="restrict other work" tag="div" class="form-group">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="restrictOtherWork" value="Yes" v-model="test.restrict_other_work">
                      <div class="state p-danger-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="restrict_other_work" value="No" v-model="test.restrict_other_work">
                      <div class="state p-success-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
              <!-- Own money on training -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Have you spent money training yourself on skills which are used in your contracting career?</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="spend own money on training" tag="div">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="own_money_on_training" value="Yes" v-model="test.own_money_on_training">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="own_money_on_training" value="No" v-model="test.own_money_on_training">
                      <div class="state p-danger-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
            </b-card>
          </div>
          <!-- Section 7 - Equipment -->
          <div class="col-12">
            <b-card header="Section 7 - Equipment" header-tag="h4" body-class="mb-3 pb-2">
              <!-- Provide own equipment -->
              <div class="row">
                <div class="col-xl-8">
                  <p class="mb-2">Are you required to provide, at your own cost your own equipment and/or materials that are significant and integral to completing the project?
                    (i.e. PPE, tools, power tools, plant, materials, vehicle)</p>
                </div>
                <div class="col-xl-4">
                  <ValidationProvider rules="required|oneOf:Yes,No" v-slot="{errors, classes}" name="provide own equipment" tag="div">
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="provide_own_equipment" value="Yes" v-model="test.provide_own_equipment">
                      <div class="state p-success-o"><label>Yes</label></div>
                    </div>
                    <div class="pretty p-default p-curve">
                      <input type="radio" name="provide_own_equipment" value="No" v-model="test.provide_own_equipment">
                      <div class="state p-warning-o"><label>No</label></div>
                    </div>
                    <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
                  </ValidationProvider>
                </div>
              </div>
            </b-card>
          </div>

          <div class="col-xl-4">
            <button @click.prevent="cancel_go_worker" class="btn orcaBtn grey_bg w-100" :disabled="saving_0">
              <span v-if="saving_0" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Going to profile ...</span>
              <span v-else>Don't Complete Test - Go Profile</span>
            </button>
          </div>
          <div class="col-xl-4">
            <button @click.prevent="save_no_assign" class="btn orcaBtn blueBtn w-100" :disabled="saving_1">
              <span v-if="saving_1" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving Test ...</span>
              <span v-else>Save test & close</span>
            </button>
          </div>
          <div class="col-xl-4">
            <button type="submit" class="btn orcaBtn w-100" :disabled="saving_2">
              <span v-if="saving_2" class="btnLoading"><i class="fas fa-spinner fa-pulse"></i>Saving Test ...</span>
              <span v-else>Save test - Assign worker</span>
            </button>
          </div>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import PrettyCheckbox from 'pretty-checkbox-vue';
import Vue from 'vue';
import Datepicker from "vuejs-datepicker";
import Multiselect from 'vue-multiselect';

Vue.use(PrettyCheckbox);

export default {
  name: "entity_test_new",
  components: {Multiselect, Datepicker},
  data() {
    return {
      saving_0: false,
      saving_1: false,
      saving_2: false,
      // current signed in crm user details
      user: this.$store.state.auth.me,
      // worker test is for
      worker: {},
      // test information
      test: {
        using_own_ltd_company: null,
        uk_tax_payer: null,
        send_substitution: null,
        s_d_c: null,
        switch_projects: null,
        named_project: null,
        how_work_performed: null,
        decide_working_hours: null,
        notice_period: null,
        offer_other_work: null,
        correct_errors: null,
        last_permanent_employer: null,
        sick_pay: null,
        holiday_entitlement: null,
        work_place_pension: null,
        maternity_paternity: null,
        paid_training: null,
        restrict_other_work: null,
        own_money_on_training: null,
        provide_own_equipment: null,

        test_expiry: this.$moment.utc().add(1, 'years').format('YYYY-MM-DD'),
        // Set log values for creating the worker (current crm user)
        log_by_type: 'App\\Models\\Users\\User',
        log_by_id: this.$store.state.auth.me.id
      },
    }
  },
  beforeMount() {
    axios.get(this.crmApiPath + 'worker/' + this.$store.state.workers.current_new_entity_test_worker_id).then(worker => this.worker = worker.data);
  },
  methods: {
    new_entity_test_submit() {
      this.$refs.newEntityTestForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.newEntityTestForm);
        }
        else {
          this.saving_2 = true;
          // success
          this.test.worker_id = this.worker.id;
          // save compliance test
          axios.post(this.crmApiPath + 'worker/compliance_test', this.test).then(assignment_id => {
            this.$store.commit('CURRENT_NEW_ASSIGNMENT_WORKER_ID', {
              worker_id: this.worker.id,
              compliance_test_id: assignment_id.data
            });
            this.$bus.$emit('entity_test::reload', {action: true});
            // Close current tab and open up worker assignment
            this.$nextTick(() => {
              this.$snotify.success('Entity Test Saved For : ' + this.worker.person.first_name + ' ' + this.worker.person.surname);
              this.saving_2 = false;
              this.$tabs.close({
                path: this.$router.currentRoute.fullPath,
                to: '/workers/assignment'
              });
              this.$tabs.refresh('/workers/assignment', true)
            })
          }).catch(error => console.log(error.response));
        }
      });
    },
    cancel_go_worker() {
      this.saving_0 = true;
      this.$store.commit('CURRENT_PROFILE_WORKER_ID', this.worker.id);
      this.$tabs.close({
        path: this.$router.currentRoute.fullPath,
        to: '/workers/profile'
      });
      this.$tabs.refresh('/workers/profile', true);
    },
    save_no_assign() {
      this.$refs.newEntityTestForm.validate().then(success => {
        if (!success) {
          this.formErrorsValidationScroll(this.$refs.newEntityTestForm);
        }
        else {
          this.saving_1 = true;
          // success
          this.test.worker_id = this.worker.id;
          // save compliance test
          axios.post(this.crmApiPath + 'worker/compliance_test', this.test).then(() => {
            this.$store.commit('CURRENT_PROFILE_WORKER_ID', this.worker.id);
            this.$bus.$emit('entity_test::reload', {action: true});
            // Close current tab and open up profile worker
            this.$nextTick(() => {
              this.$snotify.success('Entity Test Saved For : ' + this.worker.person.first_name + ' ' + this.worker.person.surname);
              this.saving_1 = false;
              this.$tabs.close({
                path: this.$router.currentRoute.fullPath,
                to: '/workers/profile'
              });
              this.$tabs.refresh('/workers/profile', true);
            })
          }).catch(error => console.log(error.response));
        }
      });
    }
  }
}
</script>

<style lang="scss" scoped>
/* PRETTY CHECKBOX MULTI LINE */
.pretty {
  white-space:   inherit;
  margin-bottom: 0.5em;

  .state {
    label {
      text-indent:  0;
      padding-left: 2rem;
      line-height:  1;

      &:after, &:before {
        top: 0;
      }
    }
  }
}

.validationError {
  background: lighten($red, 50%);
}

.vvERROR {
  margin-bottom: 20px;
}
</style>
